export const ignoreErrors = [
  /您取消了请求/gi, // promise取消请求
  /Request failed with status code 4/gi, // promise取消请求
  /Request failed with status code 5/gi, // promise取消请求
  /Failed to fetch/gi, // 无意义
  /ResizeObserver/gi, // ResizeObserver监听，不需要上报
  'ResizeObserver loop completed', // ResizeObserver监听，不需要上报
  'ResizeObserver loop limit exceeded', // ResizeObserver监听，不需要上报
  /Cannot read properties of undefined \(reading \'Q\'\)/gi, // qiankun无意义报错
  /Cannot read properties of null \(reading \'removeChild\'\)/gi, // qiankun无意义报错
  /Cannot read property \'Q\' of undefined/gi, // qiankun无意义报错
  /Cannot read property \'removeChild\' of null/gi, // qiankun无意义报错
  /promise rejection captured/gi, // UnhandledRejection无需收集
  'ChunkLoadError', // 忽略加载旧资源的报错日志
  /Loading( CSS)? chunk (.+) failed/gi, // 忽略加载旧资源的报错日志（'ChunkLoadError'不能包含 CSS，所以使用下面的正则）
  /Cannot read property 'path' of undefined/gi, // chunk-libs加载旧资源报错 Cannot read property 'path' of undefined
  /根据经纬度查询地址失败/gi, // getLngLatAddress函数抛出错误过滤
  /Network Error|NetworkError|Request aborted|Load failed|已取消/gi, // 无意义
  /Unexpected token '<'/gi, // 无意义
  /timeout of 30000ms exceeded/gi, // 无意义
  /Identifier 'a0_0x3c11c1' has already been declared/gi, // 无意义
];
